import Button from "@set-product/core/button";
import classNames from "classnames";
import WayshipDropdownDeck from "components/app/vessel/onboard/ranges/RangeManagementForm/WayshipDropdownDeck";
import WayshipNumber from "components/app/vessel/onboard/ranges/RangeManagementForm/WayshipNumber";
import WayshipTextArea from "components/app/vessel/onboard/ranges/RangeManagementForm/WayshipTextArea";
import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import {
	ECNR_BASE_RANGE_TYPE,
	ICellRangeUpdatePayload,
	ICNRCellInfo,
	ICNRRangeVesselLocalRange,
} from "redux/app/report/@types";
import reportActions from "redux/app/report/actions";
import reportSelectors from "redux/app/report/selectors";
import { ESIGNAL_REPORT_TYPE_VAL } from "redux/app/vessel/onboard/types";
import { formatSRTypeValues } from "redux/app/vessel/onboard/utils";
import { IStore } from "redux/store";

interface ITabMetricInfo {
	prefix: string;
	labels: string[];
	type: string;
	tabbedMetric: string;
}

// For generators. But not clear how to get from API.
// tabbedMetric refers to config key, that would be used to generate labels(1,2,3,4,5) that has this in it's range.
const tabMetricsInfo: ITabMetricInfo[] = [
	{
		prefix: "aux",
		labels: ["1", "2", "3", "4", "5"],
		type: "steaming",
		tabbedMetric: "aux_tabs",
	},
	{
		prefix: "mio",
		labels: ["Boiler", "IGG", "Other"],
		type: "steaming",
		tabbedMetric: "mio_tabs",
	},
	{
		prefix: "port_aux",
		labels: ["1", "2", "3", "4", "5"],
		type: "port",
		tabbedMetric: "port_aux_tabs",
	},
	{
		prefix: "port_mio",
		labels: ["Boiler", "IGG", "Other"],
		type: "port",
		tabbedMetric: "port_mio_tabs",
	},
];

type OwnProps = {
	toggleEditModalVisible: (isEditModalVisible?: boolean) => void;
	rangeInfo?: ICNRRangeVesselLocalRange;
	cellInfo: ICNRCellInfo;
	baseRangeType: ECNR_BASE_RANGE_TYPE;
	vesselIdOfCellToBeUpdated: string;
	setVesselIdOfCellToBeUpdated: React.Dispatch<React.SetStateAction<string>>;
};
type CNRRangeFormProps = PropsFromRedux & OwnProps;
function CNRRangeForm(props: CNRRangeFormProps) {
	const {
		rangeInfo,
		cellInfo,
		toggleEditModalVisible,
		baseRangeType,
		vesselIdOfCellToBeUpdated,
		setVesselIdOfCellToBeUpdated,
		jobToUpdateCell,
	} = props;

	const [tabMetricLabel, setTabMetricLabel] = useState("");

	const [formData, setFormData] = useState({
		// key: rangeInfo?.key ?? cellInfo?.key,
		metric: rangeInfo?.metric ?? cellInfo?.metric,
		modifiedAt: rangeInfo?.modifiedAt,
		range: rangeInfo?.range as number[],
		rangeType: rangeInfo?.rangeType ?? "WARNING",
		remarks: rangeInfo?.remarks ?? "",
		type: rangeInfo?.type ?? cellInfo?.type,
	});
	const [errorMessage, setErrorMessage] = useState({
		range: "",
		remarks: "",
		tab: "",
	});

	useEffect(() => {
		return () => {
			setVesselIdOfCellToBeUpdated("");
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const reportType = rangeInfo?.type ?? cellInfo?.type;
	const reportTypeSpecificTabbedMetricsInfo = tabMetricsInfo.filter(
		(tmi) =>
			tmi.type === formatSRTypeValues(reportType as ESIGNAL_REPORT_TYPE_VAL)
	);
	let isCurrentMetricInConfigRangesATabbedMetric = false;
	let tabMetricInfo: ITabMetricInfo | undefined = undefined;
	if (baseRangeType === ECNR_BASE_RANGE_TYPE.CONFIG) {
		for (let i = 0; i < reportTypeSpecificTabbedMetricsInfo.length; i++) {
			const tmi = reportTypeSpecificTabbedMetricsInfo[i];
			if (formData?.metric?.startsWith(tmi.prefix + "_")) {
				isCurrentMetricInConfigRangesATabbedMetric = true;
				tabMetricInfo = tmi;
				break;
			}
		}
	}

	return (
		<div className="flex items-center justify-center">
			<div className="w-[280px] md:w-[350px] lg:w-[450px] bg-white p-4 rounded">
				<div className="flex justify-between items-center">
					<h3 className="text-lg font-medium text-gray-700">Range Info</h3>
					<span
						onClick={() => toggleEditModalVisible(false)}
						className="bp3-icon bp3-icon-cross text-gray-700 text-lg cursor-pointer"
					/>
				</div>
				<div>
					<h4 className="mt-2">{formData?.metric}</h4>
					<div className="grid grid-cols-2 items-center gap-x-5">
						<WayshipNumber
							error={
								errorMessage?.range && {
									isValid: false,
								}
							}
							step={0.1}
							title="Min Range"
							value={`${formData?.range?.[0] ?? ""}`}
							// isSubmit={formData.metric === ''}
							dataKey={formData.metric}
							isWholeNumber={false}
							onChangeHandler={(v) => {
								if (errorMessage?.range) {
									setErrorMessage({ ...errorMessage, range: "" });
								}
								setFormData((prev) => ({
									...prev,
									range: [v, formData?.range?.[1]],
								}));
							}}
						/>
						<WayshipNumber
							error={
								errorMessage?.range && {
									isValid: false,
								}
							}
							step={0.1}
							title="Max Range"
							value={`${formData?.range?.[1] ?? ""}`}
							// isSubmit={formData.metric.value === ''}
							dataKey={formData.metric}
							isWholeNumber={false}
							onChangeHandler={(v) => {
								if (errorMessage?.range) {
									setErrorMessage({ ...errorMessage, range: "" });
								}
								setFormData((prev) => ({
									...prev,
									range: [formData.range?.[0], v],
								}));
							}}
						/>
						{errorMessage?.range ? (
							<p className="text-xs font-medium text-red-600 col-span-2">
								{errorMessage?.range}
							</p>
						) : null}
						<WayshipDropdownDeck
							title="Select range type"
							dataKey=""
							value={formData?.rangeType ?? "WARNING"}
							range={[
								{
									label: "Warning",
									value: "WARNING",
								},
								{
									label: "Error",
									value: "ERROR",
								},
							]}
							isSubmit={formData?.range?.every((rangeVal) => !rangeVal)}
							onChangeHandler={(selectedItem: any, dataKey: any) => {
								if (selectedItem) {
									setFormData((prev) => ({
										...prev,
										rangeType: selectedItem,
									}));
								}
							}}
						/>

						<div className="">
							<label className="ws-input__label inline-block -mt-3 pb-2">
								Report Type
							</label>
							<div className="h-[39px] text-sm pt-1 px-2">
								{formData?.type?.toUpperCase()}
							</div>
						</div>

						{isCurrentMetricInConfigRangesATabbedMetric ? (
							<WayshipDropdownDeck
								title="Select Tab"
								error={
									errorMessage?.tab && {
										isValid: false,
										message: errorMessage?.tab,
									}
								}
								dataKey={tabMetricInfo?.prefix}
								value={tabMetricLabel}
								range={tabMetricInfo?.labels?.map((tab) => ({
									label: tab,
									value: tab,
								}))}
								isSubmit={formData?.range?.every((rangeVal) => !rangeVal)}
								onChangeHandler={(selectedItem: any, dataKey: any) => {
									if (errorMessage?.tab) {
										setErrorMessage({ ...errorMessage, tab: "" });
									}
									if (selectedItem) {
										setTabMetricLabel(selectedItem);
									}
								}}
							/>
						) : null}
					</div>
					<WayshipTextArea
						title="Remarks"
						value={formData?.remarks}
						isSubmit={formData.metric === ""}
						dataKey=""
						onChange={(v) => {
							setFormData((prev) => ({
								...prev,
								remarks: v,
							}));
						}}
						error={
							errorMessage?.remarks && {
								isValid: false,
								message: errorMessage?.remarks,
							}
						}
					/>

					<div className="mt-4 flex justify-end items-center">
						<div className="flex items-center space-x-4 ">
							<Button
								onClick={(e) => {
									e.preventDefault();

									if (
										Object.keys(errorMessage).some(
											(emK) =>
												(errorMessage as any)[emK] &&
												!!(errorMessage as any)[emK]?.length
										)
									)
										return;

									let minRange = formData?.range?.[0];
									let maxRange = formData?.range?.[1];
									const isMinRangeEmpty =
										minRange === undefined ||
										minRange === null ||
										`${minRange}`.trim().length === 0;
									const isMaxRangeEmpty =
										maxRange === undefined ||
										maxRange === null ||
										`${maxRange}`.trim().length === 0;

									if (isMinRangeEmpty && isMaxRangeEmpty) {
										setErrorMessage({
											...errorMessage,
											range: "Both range can't be empty",
										});
										return;
									} else if (
										!isMinRangeEmpty &&
										!isMaxRangeEmpty &&
										Number(minRange) >= Number(maxRange)
									) {
										setErrorMessage({
											...errorMessage,
											range:
												"Min range can't be equal to or greater than Max range.",
										});
										return;
									}

									if (!formData?.remarks?.trim()?.length) {
										setErrorMessage({
											...errorMessage,
											remarks: "Remarks cannot be empty.",
										});
										return;
									}

									if (
										isCurrentMetricInConfigRangesATabbedMetric &&
										!tabMetricLabel
									) {
										setErrorMessage({
											...errorMessage,
											tab: "Select the tab option.",
										});
										return;
									}

									let updatedData: ICellRangeUpdatePayload = {
										vesselId: vesselIdOfCellToBeUpdated,
										metricKey: cellInfo?.key,
										metricTitle: formData?.metric,
										kind: "cnr",
										newRange: [+minRange, +maxRange] as [number, number],
										rangeType: formData?.rangeType,
										remarks: formData?.remarks,
										type: formatSRTypeValues(
											formData?.type as ESIGNAL_REPORT_TYPE_VAL
										) as string,
									};

									// if (
									// 	isCurrentMetricInConfigRangesATabbedMetric &&
									// 	tabMetricLabel
									// ) {
									// 	updatedData = {
									// 		...updatedData,
									// 		metricKey: `${formData?.metric}_cur_${tabMetricLabel}`,
									// 	};
									// }

									// send updatedData to api.
									props.updateCNRRange(updatedData);
								}}
								disabled={jobToUpdateCell.isLoading}
								className={classNames("bg-blue-500", {

									"pointer-events-none bg-gray-200 text-gray-100": jobToUpdateCell.isLoading,
								})}
							>
								Save
							</Button>
							<Button
								onClick={(e) => {
									toggleEditModalVisible(false);
								}}
								className="bg-red-500"
							>
								Cancel
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const reportStore = reportSelectors._getStore(store);
	const jobToUpdateCell = reportSelectors.jobToUpdateCNRRangesCell(reportStore);
	return {
		jobToUpdateCell,
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {
		// TODO: needs to be changed according to the api contract/requirements
		updateCNRRange(rangeInfo: ICellRangeUpdatePayload) {
			return dispatch(
				reportActions.commands.cnrRangesRangeCellUpdate(rangeInfo)
			);
		},
	};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(CNRRangeForm);
